import Grid from '@mui/material/Grid';
import { SxProps } from '@mui/material/styles';

import { DinerAuthenticationInput } from 'reservations/dinerAccount/components/DinerAuthenticationInput';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import EmailFormField from 'reservations/form/components/EmailFormField';
import NameFormField from 'reservations/form/components/NameFormField';
import PhoneNumberFormField from 'reservations/form/components/PhoneNumberFormField';

type DinerLoginFieldsProps = {
  sxOverride?: SxProps;
  labelSxOverride?: SxProps;
  authSxOverride?: SxProps;
  authInputSxOverride?: SxProps;
  errorColorOverride?: SxProps;
};

export const DinerLoginFields = ({
  sxOverride = {},
  labelSxOverride = {},
  authSxOverride = {},
  authInputSxOverride = {},
  errorColorOverride = {}
}: DinerLoginFieldsProps) => {
  const { dinerAccountExists, isSmsAuthDisabled, setBeginAuthParams } =
    useDinerAccount();

  const handleEmailOnBlur = (value: string) => {
    if (!isSmsAuthDisabled) {
      setBeginAuthParams(value);
    }
  };

  return (
    <>
      <Grid item>
        <EmailFormField
          autoFocus
          handleOnBlur={handleEmailOnBlur}
          sxOverride={sxOverride}
          labelSxOverride={labelSxOverride}
          errorColorOverride={errorColorOverride}
        />
      </Grid>
      {dinerAccountExists ? (
        <DinerAuthenticationInput
          sxOverride={authSxOverride}
          sxInputOverride={authInputSxOverride}
          errorColorOverride={errorColorOverride}
        />
      ) : (
        <>
          <Grid item>
            <NameFormField
              sxOverride={sxOverride}
              labelSxOverride={labelSxOverride}
              errorColorOverride={errorColorOverride}
            />
          </Grid>
          <Grid item>
            <PhoneNumberFormField
              sxOverride={sxOverride}
              labelSxOverride={labelSxOverride}
              errorColorOverride={errorColorOverride}
            />
          </Grid>
        </>
      )}
    </>
  );
};
